import React, { useContext } from 'react'
import SearchBox from 'widgets/SearchBox'
import DrupalContext from 'contexts/DrupalContext'
import LocalPageTemplate from '../templates/LocalPageTemplate'

function Widget() {
  const drupal = useContext(DrupalContext)

  switch (drupal.niche) {
    case 'local_page':
      return (<LocalPageTemplate />)
    default:
      return (<SearchBox />)
  }
}
export default Widget
